import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import { when } from "@/common/directives/when";
import EkoElement from "@/utilities/element";
import type { TabVariant } from "../index";
import style from "./tab.css?inline";

@customElement("eko-tab")
class Tab extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) active = false;
  @property({ reflect: true }) href: string | null = null;
  @property({ reflect: true }) size: "sm" | "md" = "md";

  @property({ reflect: true }) variant: TabVariant = "default";

  render() {
    const tagName = unsafeStatic(this.tag);

    return html`<${tagName}
      class="eko-tab"
      part="root"
      role="tab"
      aria-selected=${this.active}
      href=${when(this.href, this.href)}>
      <slot name="before"></slot>
      <slot></slot>
      <slot name="after"></slot>
    </${tagName}>`;
  }

  private get tag() {
    return this.href !== null ? "a" : "div";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-tab": Tab;
  }
}

export default Tab;
